module.exports = "/_next/static/images/dbd2cca3bb77e24df43d7b0c222cb1bc-wow-2@1x.svg";